<template>
  <div class="container">
    <card>
      <div class="card-bpdy">
        <h2>Access to this page is restricted</h2>
        <p>
          Please check with the site admin if you believe this is a mistake.
        </p>
      </div>
    </card>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" >
</style>